import styles from './ActionHeader.module.css';

import { HelpLink, LanguageToggle, SigninOrSignout } from 'components';
import UvALogo from 'assets/images/UvALogo.svg';
import { APP_ROOT } from 'routes';

interface Props {
  userUnavailable?: boolean;
}

export function ActionHeader({ userUnavailable }: Props) {
  return (
    <div className={styles['action-header']}>
      <div className={styles['action-header__menu']}>
        <a href={APP_ROOT}>
          <img src={UvALogo} alt="UvA logo" className={styles['action-header-logo']} />
        </a>
      </div>
      <div className={styles['action-header__actions']} id="action-header-actions" tabIndex={-1}>
        <LanguageToggle />
        <HelpLink />
        <SigninOrSignout userUnavailable={userUnavailable} />
      </div>
    </div>
  );
}
